import React from "react";
import { QRCodeCanvas } from "qrcode.react";

export default function QRCodeCard({ text }) {
  return (
    <div className=" mx-auto w-full max-w-[12rem] relative text-center">
      <div className="ml-4 ">
        <div className="bg-zinc-50 rounded-lg p-3">
          <QRCodeCanvas
            size={150}
            id="upi-qrcode"
            renderas="canvas"
            value={text}
            bgColor={"#fafafa"}
          />
        </div>
      </div>
    </div>
  );
}
